<template>
<div class="chapter">
<div class="inner_page">
<p class="C102"><i><a id="page_5"></a>For<br/>
</i><span class="sm">PETER OLDHAM</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part0002.vue?b3ff68c4